<dialog [open]="isOpen$ | async" class="instagram-dialog">
  @if ({ item: selectedItem$ | async }; as data) {
    <div class="desktop-nav">
      <div #prevBtn (click)="prevItem()" class="prev"><i iconName="CHEVRON_LEFT"></i></div>
      <div #nextBtn (click)="nextItem()" class="next"><i iconName="CHEVRON_RIGHT"></i></div>
    </div>
    <div #instagramWrapper class="instagram-wrapper">
      <i (click)="closeDialog()" class="mobile-close" iconName="CLOSE"></i>
      <div #picture class="picture">
        @if (data.item?.images; as images) {
          @if (images.length > 1) {
            <div class="internal-carousel">
              <div #internalCarouselInner (touchend)="resetSelectedInternalItemIndex()" class="internal-carousel-inner">
                @for (image of images; track image) {
                  <div #internalItem class="internal-item">
                    @if (imageReady()) {
                      <app-image
                        [image]="images[0]!"
                        [size]="{ dw: pictureWidth(), mw: pictureWidth() }"
                        [keepAspectRatio]="true" />
                    }
                  </div>
                }
              </div>
            </div>
            <div class="btn-action">
              <span (click)="scrollPrev()" class="prev"><i [size]="'1.6rem'" iconName="CHEVRON_LEFT"></i></span>
              <span (click)="scrollNext()" class="next"><i [size]="'1.6rem'" iconName="CHEVRON_RIGHT"></i></span>
            </div>
            <div class="indicators-wrapper">
              <div class="indicators">
                @for (image of images; track image; let i = $index) {
                  <div
                    (click)="selectInternalItem(i)"
                    [class.indicator-active]="i === selectedInternalItemIndex()"
                    class="indicator"></div>
                }
              </div>
            </div>
          } @else {
            @if (imageReady()) {
              <app-image
                [image]="images[0]!"
                [size]="{ dw: pictureWidth(), mw: pictureWidth() }"
                [keepAspectRatio]="true" />
            }
          }
          <ng-template #picture>
            @if (imageReady()) {
              <app-image
                [image]="images[0]!"
                [size]="{ dw: pictureWidth(), mw: pictureWidth() }"
                [keepAspectRatio]="true" />
            }
          </ng-template>
        }
      </div>
      <div #contentWrapper class="content-wrapper">
        <div class="desktop-close">
          <i (click)="closeDialog()" iconName="CLOSE"></i>
        </div>
        <div class="content">
          @if (flux().account; as account) {
            <div class="account">
              <a [href]="account.link" class="account-avatar" target="_blank">
                <app-image
                  [image]="account.picture"
                  [size]="{ dw: 40, dh: 40, mw: 40, mh: 40 }"
                  [style]="{ 'border-radius.%': 50 }" />
              </a>
              <a [href]="account.link" class="account-name" target="_blank">{{ account.name }}</a>
            </div>
          }
          @if (data.item; as item) {
            <div class="post-date">
              <a [href]="item.url" target="_blank">{{ item?.date }}</a>
            </div>
          }
          <div [innerHTML]="data.item?.description" class="description"></div>
        </div>
      </div>
      <div class="mobile-nav">
        <div (click)="prevItem()" class="prev"><i iconName="CHEVRON_LEFT"></i></div>
        <div (click)="nextItem()" class="next"><i iconName="CHEVRON_RIGHT"></i></div>
      </div>
    </div>
  }
</dialog>
